import React from "react";
import { AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import "./TickerFilter.scss";

type TickerFilterProps = {
  allTickers: string[];
  onChange: (value: string) => void;
  selectedTicker?: string;
};

const TickerFilter = (props: TickerFilterProps) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    props.selectedTicker
  );

  const [searchText, setSearchText] = useState("");

  //  Popular suggestions (default state)
  const popularTickers = props.allTickers.slice(0, 5);

  //  Highlight match
  const highlightText = (text: string, input: string) => {
    if (!input) return text;

    const index = text.toLowerCase().indexOf(input.toLowerCase());
    if (index === -1) return text;

    return (
      <>
        {text.substring(0, index)}
        <span className="highlight">
          {text.substring(index, index + input.length)}
        </span>
        {text.substring(index + input.length)}
      </>
    );
  };

  //  Simple fuzzy match (spelling mistake handling)
  const isFuzzyMatch = (text: string, input: string) => {
    let t = text.toLowerCase();
    let i = input.toLowerCase();

    let ti = 0,
      ii = 0;

    while (ti < t.length && ii < i.length) {
      if (t[ti] === i[ii]) ii++;
      ti++;
    }

    return ii === i.length;
  };

  //  Dynamic options
  const options = (searchText ? props.allTickers : popularTickers).map(
    (ticker) => ({
      value: ticker,
      label: (
        <div className="option-item">
          {highlightText(ticker, searchText)}
        </div>
      ),
    })
  );

  // Update selected value from parent
  useEffect(() => {
    setSelectedValue(props.selectedTicker);
  }, [props.selectedTicker]);

  return (
    <div className="ticker-filter">
      <AutoComplete
        style={{ width: "100%" }}
        placeholder="Search here . . ."
        allowClear={true}
        defaultActiveFirstOption={false}
        options={options}
        value={selectedValue}
        onSearch={(value) => {
          setSearchText(value);
        }}
        filterOption={(inputValue, option) => {
          const val = option?.value ?? "";

          const input = inputValue.toLowerCase();

          return (
            val.toLowerCase().includes(input) || // normal match
            isFuzzyMatch(val, input) // fuzzy match
          );
        }}
        onChange={(value) => {
          setSelectedValue(value);
          props.onChange(value);
        }}
        onSelect={(value) => {
          setSelectedValue(value); // autofill
          props.onChange(value);
        }}
      />
      <SearchOutlined className="search-icon" />
    </div>
  );
};

export default TickerFilter;